import { createFileRoute } from "@tanstack/react-router";
import { SupplierPricedDeliverableTab } from "../../../../pages/suppliers-page/supplier-priced-deliverable-tab";

export const Route = createFileRoute("/_auth/_frame/suppliers/$supplierId/priced-deliverables")({
  component: SupplierPricedDeliverableTab,
});
